module.exports = __webpack_public_path__ + "img/error-dark.173908b0.svg";